import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const SVG = styled('svg')``;

SVG.defaultProps = {
    xmlns: 'http://www.w3.org/2000/svg',
};

SVG.propTypes = {
    xmlns: PropTypes.string.isRequired,
    viewbox: PropTypes.string,
};

export default SVG;
